import { combineReducers } from "redux";
import { LOGOUT_SUCCESS } from "./login/constants";
import loginReducer from "./login/reducer";
import signUpReducer from "./signup/reducer";
import forgotReducer from "./forgotPassword/reducer";
import {
  vehicleReducer,
  getVehicleListReducer,
  vehicleDetailsUploadImageReducer,
  deleteVehicleReducer,
  setSelectedVehicleReducer,
} from "./vehicle/reducer";
import driverReducer from "./driver/reducer";
import operatorReducer from "./operator/reducer";
import verifyUserReducer from "./verifyUser/reducer";
import uploadDocReducer from "./uploadDocuments/reducer";
import menuBarReducer from "./menuBar/reducer";
import reservationReducer from "./reservations/reducer";
import storageDocumentReducer from "./storageDocument/reducer";
import myDocumentsReducer from "./myDocuments/reducer";
import profileReducer from "./profile/reducer";
import paymentsReducer from "./payments/reducer";
import paymentInvoice from "./paymentInvoice/reducer";

const appReducer = combineReducers({
  loginReducer: loginReducer,
  signUpReducer: signUpReducer,
  forgotReducer: forgotReducer,
  vehicleReducer: vehicleReducer,
  getVehicleListReducer: getVehicleListReducer,
  vehicleDetailsUploadImageReducer: vehicleDetailsUploadImageReducer,
  deleteVehicleReducer: deleteVehicleReducer,
  setSelectedVehicleReducer: setSelectedVehicleReducer,
  driverReducer: driverReducer,
  operatorReducer: operatorReducer,
  verifyUserReducer: verifyUserReducer,
  uploadDocReducer: uploadDocReducer,
  menuBarReducer: menuBarReducer,
  reservationReducer: reservationReducer,
  storageDocumentReducer: storageDocumentReducer,
  myDocumentsReducer: myDocumentsReducer,
  profileReducer: profileReducer,
  paymentsReducer: paymentsReducer,
  paymentInvoiceReducer: paymentInvoice,
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT_SUCCESS) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
